"use client";
import Image from "next/image";
import { useState } from "react";

const topics = [
  {
    title: "About Vell",
    description: "Get to know who are we and how do we keep your money and data safe",
    href: "/frequently-asked-questions/about-vell",
    icon: (
      <Image
        src="/V_transparent.png"
        alt="Vell logo"
        width={24}
        height={24}
        className="w-6 h-6 3xl:w-8 3xl:h-8 fill-current"
      />
    ),
  },
  {
    title: "Sending Money",
    description:
      "Learn how to set up transfers, where you can send money and what currency options are available",
    href: "/frequently-asked-questions/sending-money",
    icon: (
      <svg viewBox="0 0 448 512" className="w-6 h-6 3xl:w-8 3xl:h-8 fill-current">
        <path d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z" />
      </svg>
    ),
  },
  {
    title: "Pricing and Fees",
    description: "We believe in transparent pricing. Here's what you need to know",
    href: "/frequently-asked-questions/pricing-and-fees",
    icon: (
      <svg viewBox="0 0 288 512" className="w-6 h-6 3xl:w-8 3xl:h-8 fill-current">
        <path d="M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z" />
      </svg>
    ),
  },
  {
    title: "Transfer Time and Tracking",
    description: "Find out how to follow your payment in real time",
    href: "/frequently-asked-questions/transfer-time-and-tracking",
    icon: (
      <svg viewBox="0 0 512 512" className="w-6 h-6 3xl:w-8 3xl:h-8 fill-current">
        <path d="M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z" />
      </svg>
    ),
  },
  {
    title: "Scheduled Payments",
    description: "Set up recurring transfers with ease. Here's how",
    href: "/frequently-asked-questions/scheduled-payments",
    icon: (
      <svg viewBox="0 0 24 24" className="w-6 h-6 3xl:w-8 3xl:h-8 fill-current" aria-hidden="true">
        <path d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1zm12 7H5v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm-8 7a1 1 0 0 1-.7-.29l-2-2a1 1 0 1 1 1.4-1.42l1.3 1.3 3.3-3.3a1 1 0 1 1 1.4 1.42l-4 4a1 1 0 0 1-.7.29z" />
      </svg>
    ),
  },
];

export default function FAQPage() {
  const [search, setSearch] = useState("");

  const filtered = topics.filter((t) => {
    const q = search.toLowerCase();
    return t.title.toLowerCase().includes(q) || t.description.toLowerCase().includes(q);
  });

  return (
    <div className="py-16 bg-brand-text">
      <div className="lg:max-w-4xl xl:max-w-6xl 3xl:max-w-[1432px] px-4 lg:px-0 mx-auto">
        <div className="mb-10 sm:mb-2 text-center sm:py-16">
          <h1 className="text-5xl lg:text-6xl xl:text-7xl 3xl:text-8xl font-bold text-brand-card leading-[1.08] tracking-tight mb-5">
            Explore all topics
          </h1>
          <div className="relative mt-8 max-w-xl mx-auto">
            <svg
              className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-brand-card/50 pointer-events-none"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
            >
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
            <input
              type="text"
              placeholder="Search topics..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full pl-12 pr-4 py-3 global-border-radius bg-brand-text border border-brand-grey focus:border-brand-teal focus:outline-none text-brand-card placeholder:text-brand-card/40 text-base transition"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {filtered.length > 0 ? (
            filtered.map((item) => (
              <a
                key={item.title}
                href={item.href}
                className="
                  group global-border-radius p-7 min-h-[260px]
                  flex flex-col justify-center text-center
                  bg-brand-text
                  border border-brand-grey hover:border-brand-teal
                  transition-all
                "
              >
                <div
                  className="
                    mx-auto
                    mb-4
                    flex

                    items-center
                    justify-center
                    global-border-radius
                    bg-brand-text/60
                    text-brand-card
                    transition
                    group-hover:bg-brand-grey
                  "
                >
                  {item.icon}
                </div>
                <h3 className="font-semibold text-2xl mb-2 text-brand-card 3xl:text-[2rem]">{item.title}</h3>
                <p className="!text-brand-card/80 leading-relaxed text-lg 3xl:text-xl">{item.description}</p>
              </a>
            ))
          ) : (
            <p className="col-span-full text-center text-brand-card py-16 text-lg">
              No topics found for &ldquo;{search}&rdquo;
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
